import { toolkitCx } from "@sundae/ui-toolkit";
import { TSize } from "@sundae/ui-toolkit/dist/types/types/shared.types";
import cx from "classnames";
import { FC, memo } from "react";

interface ITextLoadingPlaceholderProps {
  className?: string;
  size?: TSize;
}

const TextLoadingPlaceholder: FC<ITextLoadingPlaceholderProps> = ({ className, size = "md" }) => {
  return (
    <div
      className={cx(
        className,
        "inline-block rounded-lg align-middle motion-safe:animate-pulse",
        toolkitCx.layout.background.loading,
        {
          "h-3 w-16": size === "xs",
          "h-4 w-24": size === "sm",
          "h-5 w-32": size === "md",
          "h-6 w-40": size === "lg",
          "h-8 w-56": size === "xl",
        }
      )}
    />
  );
};

export default memo(TextLoadingPlaceholder);
